import Logger from 'services/logger';
export const validateIfHasSensitiveContent = async (
  event,
  sensitiveRatingsList,
) => {
  const parentalRatingFromEvent = event?.parental_rating;

  try {
    if (!sensitiveRatingsList?.length) return false;
    if (!parentalRatingFromEvent) return false;

    return sensitiveRatingsList.find(
      rating => rating?.parental_rating === parentalRatingFromEvent,
    );
  } catch (error) {
    Logger.error('Error checking sensitive rating:', error);
    return false;
  }
};
